import s from "./content.module.css";
import {useContent} from "./useContent";
import {ATTENDANCE_PICKER_DATA_ENUM} from "../../../../../utils";
import {nadWhiteArrow} from "../../../../../assets";
import {h} from "preact";
import {useAppContext} from "../../../../../contexts";

const Content = (props) => {
    // Destructured props
    const {
        sidebarCartData,
        handleCart,
        handleIsOpen
    } = props;

    // Component logic data
    const componentProps = useContent({
        sidebarCartData,
        handleCart
    });

    // Destructured component logic data
    const {
        handleApproval
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Prevents unwanted errors
    if (Object.keys(sidebarCartData.lastWarehouseAdded).length < 1) {
        return null;
    }

    // The variable name says it all
    const addressZipCode =
        !sidebarCartData.lastWarehouseAdded.data.zipCode ? null : (
            <span className={`${highContrast ? "text-[#fecc31]" : "text-[#398948]"}`}>
                {` ${sidebarCartData.lastWarehouseAdded.data.zipCode}`}
            </span>
        );

    return (
        <div className={`font-museo ${s.root}`}>
            <h1 className={`${s.title} ${highContrast ? "highTitleThird" : ""}`}>
                Deseja adicionar o Serviço no mesmo atendimento?
            </h1>
            <div className={"w-full relative z-0"}>
                <div className={`${s.attendancePill}`}>
                    <div className={`${s.pill} ${highContrast ? s.highContrastPill : ""}`} />
                    <img
                        src={ATTENDANCE_PICKER_DATA_ENUM[sidebarCartData.lastWarehouseAdded.type].icon}
                        alt="Attendance icon"
                    />
                    <p className={`${s.attendanceTypeLabel}`}>
                        {ATTENDANCE_PICKER_DATA_ENUM[sidebarCartData.lastWarehouseAdded.type].name}
                    </p>
                </div>
                <div className={`${s.attendanceInfoBlock} ${highContrast ? "text-[#fecc31]" : "text-[#4C4C4C]"}`}>
                    <h1>
                        {
                            sidebarCartData.lastWarehouseAdded.data.address ||
                            sidebarCartData.lastWarehouseAdded.data.label
                        }
                        {addressZipCode}
                    </h1>
                </div>
            </div>
            <div className={`${s.actionBlock}`}>
                <button
                    type={"button"}
                    className={`${s.actionButton} ${s.noButton}`}
                    onClick={() => handleIsOpen()}
                >
                    Não
                </button>
                <button
                    type={"button"}
                    className={`${s.actionButton} ${s.yesButton} ${highContrast ? s.highContrastButton : "text-white"}`}
                    onClick={() => handleApproval()}
                >
                    Sim
                    <img
                        src={nadWhiteArrow}
                        className={s.whiteArrow}
                        alt={"White arrow"}
                    />
                </button>
            </div>
        </div>
    )
}

export default Content;
